module.exports = __webpack_public_path__ + "img/clogo15.6c4c0178.png";